import type { ReactNode } from 'react';
import { maskPhone, unmaskPhone } from '@/shared/lib/phone';
import { MaskedInput, type MaskedInputProps } from './masked-input';

/** Props do PhoneInput: o valor é sempre o telefone só com dígitos. */
export type PhoneInputProps = MaskedInputProps;

/** Campo de telefone brasileiro com DDD (fixo ou celular); entrega só os dígitos. */
export function PhoneInput({
  placeholder = '(00) 00000-0000',
  ...props
}: PhoneInputProps): ReactNode {
  return (
    <MaskedInput
      inputMode="tel"
      type="tel"
      {...props}
      placeholder={placeholder}
      mask={maskPhone}
      unmask={unmaskPhone}
    />
  );
}
